export const SERVICE_ITEM_DISPLAY_NONE = false;
export const SERVICE_ITEM_DISPLAY_ALL = true;
export const SERVICE_ITEM_DISPLAY_EMPTY = '';
export const SERVICE_ITEM_DISPLAY_OPTIONS = [
  {
    text: 'None',
    value: SERVICE_ITEM_DISPLAY_NONE,
    key: SERVICE_ITEM_DISPLAY_NONE,
  },
  {
    text: 'All',
    value: SERVICE_ITEM_DISPLAY_ALL,
    key: SERVICE_ITEM_DISPLAY_ALL,
  },
];
